export const alen = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 20,
  inputPaddingInline: 20,

  inputHeight: 36,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 14,
  inputFontFamily: '"Franklin Gothic ATF", sans-serif',
  inputColor: "#6B6C6C",
  inputBackgroundColor: "#fff",
  inputFontWeight: 500,

  inputBorderColor: "#707070",
  inputBorderWidth: 1,
  inputBorderRadius: 0,

  inputHoverColor: "#6B6C6C",
  inputHoverBorderColor: "#707070",
  inputHoverBackgroundColor: "#fff",

  // **********************************
  //  Select field
  selectTopSpacing: 20,
  selectPaddingInline: 20,

  selectHeight: 36,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 14,
  selectFontFamily: '"Franklin Gothic ATF", sans-serif',
  selectColor: "#6B6C6C",
  selectBackgroundColor: "#fff",
  selectFontWeight: 500,

  selectBorderColor: "#707070",
  selectBorderWidth: 1,
  selectBorderRadius: 0,

  selectHoverColor: "#6B6C6C",
  selectHoverBorderColor: "#707070",
  selectHoverBackgroundColor: "#fff",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 20,
  textAreaPaddingInline: 20,

  textAreaHeight: 36,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 14,
  textAreaFontFamily: '"Franklin Gothic ATF", sans-serif',
  textAreaColor: "#6B6C6C",
  textAreaBackgroundColor: "#fff",
  textAreaFontWeight: 500,

  textAreaBorderColor: "#707070",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 0,

  textAreaHoverColor: "#6B6C6C",
  textAreaHoverBorderColor: "#707070",
  textAreaHoverBackgroundColor: "#fff",

  // **********************************
  //  placeholder
  placeholderColor: "#B8B8B8",
  placeholderFontFamily: '"Franklin Gothic ATF", sans-serif',
  placeholderFontSize: 14,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#B8B8B8",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 6,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 14,
  fieldLabelColor: "#6B6C6C",
  fieldLabelFontWeight: 500,
  fieldLabelColorAsterisk: "#6B6C6C",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Franklin Gothic ATF", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#6B6C6C",
  descriptionFontSize: 14,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Franklin Gothic ATF", sans-serif',
  descriptionTopSpacing: 5,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 27,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 3,
  checkboxUncheckedBorderColor: "#B8B8B8",
  checkboxUncheckedBackgroundColor: "#fff",
  checkboxCheckedBackgroundColor: "#00AEA9",
  checkboxCheckedBorderColor: "#B8B8B8",
  checkboxCheckedColor: "#fff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Franklin Gothic ATF", sans-serif',
  checkboxLabelFontSize: 14,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#6B6C6C",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 15,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#B8B8B8",
  radioUncheckedBackgroundColor: "#fff",
  radioCheckedBackgroundColor: "#00AEA9",
  radioCheckedBorderColor: "#B8B8B8",

  radioAlignment: "none",

  radioLabelFontFamily: '"Franklin Gothic ATF", sans-serif',
  radioLabelFontSize: 14,
  radioLabelFontWeight: 400,
  radioLabelColor: "#6B6C6C",

  // **********************************
   // Toggle

   toggleLabelFontFamily: '"Franklin Gothic ATF", sans-serif',
   toggleLabelFontSize: 14,
   toggleLabelFontWeight: 400,
   toggleLabelColor: "#6B6C6C",
 
   // **********************************
  // submit button

  submitMarginTop: 36,
  submitFontSize: 16,
  submitFontFamily: "'Franklin Gothic ATF', sans-serif",
  submitWidth: 100,
  submitWidthUnits: "%",
  submitHeight: 41,
  submitBorderRadius: 21,
  submitBorderWidth: 1,
  submitBackground: "#00AEA9",
  submitColor: "#fff",
  submitBorderColor: "#00AEA9",
  submitBackgroundHover: "#00AEA9",
  submitBorderColorHover: "#00AEA9",
  submitColorHover: "#fff",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 400,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "center",
};

  